import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { PasswordlessAccess } from './passwordless-access.model';

export class PasswordlessAccessStateModel extends EntityStateModel<PasswordlessAccess> {}
